/* eslint-disable */
import OnlinePredictionIcon from '@mui/icons-material/OnlinePrediction'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { CircularProgress, Collapse, Menu, MenuItem, TableHead } from '@mui/material'
import Box from '@mui/material/Box'
import IconButton from '@mui/material/IconButton'
import Paper from '@mui/material/Paper'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableRow from '@mui/material/TableRow'
import Tooltip from '@mui/material/Tooltip'
import * as React from 'react'
import { useEffect, useState } from 'react'
import { Button } from 'react-bootstrap'
import ApiService from '../../../ApiService'
import {
  EMULATOR_DELETE_URL,
  UPDATE_INTERVAL,
  USER_ASSIGN_EMULATOR_URL,
  USER_CHANGE_STATUS_URL,
  USER_URL
} from '../../../constants'
import { useEmulatorStore } from '../../../stores/emulator/store.tsx'
import { CustomTablePagination } from '../../CustomTablePagination'
import { EnhancedTableToolbar, getComparator, stableSort } from './stableSort'

function formatRegisteredDate(isoDate) {
  if (!isoDate) return 'N/A'
  const d = new Date(isoDate)
  if (Number.isNaN(d.getTime())) return 'N/A'
  return new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: 'long',
    year: 'numeric'
  }).format(d)
}

function statusBadgeSx(status) {
  const u = String(status || 'N/A').toUpperCase()
  if (u === 'ACTIVE') {
    return {
      bgcolor: '#e8f5e9',
      color: '#2e7d32',
      border: '1px solid #a5d6a7'
    }
  }
  if (u === 'OFFLINE') {
    return {
      bgcolor: '#ffebee',
      color: '#c62828',
      border: '1px solid #ef9a9a'
    }
  }
  return {
    bgcolor: '#fff8e1',
    color: '#e65100',
    border: '1px solid #ffe082'
  }
}

const INTERVAL_OPTIONS = [
  { value: 1, label: '1 Second' },
  { value: 5, label: '5 Seconds' },
  { value: 15, label: '15 Seconds' },
  { value: 30, label: '30 Seconds' }
]

export default function UserTable({
  showToast,
  handleEditButtonClick,
  userEditedId,
  userAssingedEmulator,
  setUserAssingedEmulator,
  updatedData,
  handleOpen,
  handleGeneratedIdButtonClick,
  updatedEmulator
}) {
  const [order, setOrder] = React.useState('asc')
  const [orderBy, setOrderBy] = React.useState('calories')
  const [page, setPage] = React.useState(0)
  const [rowsPerPage, setRowsPerPage] = React.useState(10)

  const totalEmulators = useEmulatorStore.getState().emulators

  const [loading, setLoading] = React.useState(true)
  const [error, setError] = React.useState(null)

  const [userData, setUserData] = React.useState([])
  const [dataUpdated, setDataUpdated] = useState(false)

  const [userDetails, setUserDetails] = React.useState()

  const [enableDisableDetails, setEnableDisableDeatils] = useState({
    id: '',
    status: ''
  })

  const [expandedIds, setExpandedIds] = React.useState(() => new Set())
  const [emulatorByUser, setEmulatorByUser] = React.useState({})
  const [loadingEmulatorsFor, setLoadingEmulatorsFor] = React.useState({})
  const [intervalMenu, setIntervalMenu] = React.useState({
    anchorEl: null,
    emulator: null,
    ownerUserId: null
  })
  const [nestedDeleteDetails, setNestedDeleteDetails] = React.useState({
    emulator: null,
    userId: null
  })
  const [nestedUnassignDetails, setNestedUnassignDetails] = React.useState({
    emulator: null,
    userId: null
  })

  const expandedIdsRef = React.useRef(expandedIds)
  React.useEffect(() => {
    expandedIdsRef.current = expandedIds
  }, [expandedIds])

  useEffect(() => {
    if (!dataUpdated) {
      fetchUsers()
    }
  }, [dataUpdated])

  React.useEffect(() => {
    const refreshEditedUser = async (userId) => {
      const token = localStorage.getItem('token')
      const { success, data, error: err } = await ApiService.makeApiCall(
        USER_URL,
        'GET',
        null,
        token,
        userId
      )
      if (success) {
        const updatedData = userData.map((item) => {
          if (item.id === data.id) {
            return data
          }
          return item
        })
        setUserData(updatedData)
        console.error('updatedData : ', updatedData)
      } else {
        console.error('refreshEditedUser error : ' + err)
        showToast('Failed to update user table', 'error')
        return { success: false, error: 'Failed to unassign user' }
      }
    }
    if (userEditedId !== null) {
      if (userEditedId === 0) {
        fetchUsers()
        setDataUpdated(false)
      } else {
        refreshEditedUser(userEditedId)
      }
    }
  }, [userEditedId, updatedData])

  const refreshUserEmulatorCounts = React.useCallback(
    async (userId) => {
      const token = localStorage.getItem('token')
      try {
        const response = await fetch(`${USER_URL}/${userId}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          }
        })
        if (!response.ok || response.status !== 200) {
          if (userId !== undefined) {
            showToast('Failed to update user table', 'error')
          }
          return
        }
        const responseData = await response.text()
        const result = JSON.parse(responseData)
        setUserData((prev) =>
          prev.map((item) => {
            if (item.id === result.id) {
              return {
                ...item,
                emulatorCount: {
                  ...item.emulatorCount,
                  allEmulatorsCount: result.emulatorCount?.allEmulatorsCount,
                  activeEmulatorsCount: result.emulatorCount?.activeEmulatorsCount
                }
              }
            }
            return item
          })
        )
      } catch (err) {
        console.error('refreshUserEmulatorCounts error : ' + err)
        showToast(`Failed to update user table ${err}`, 'error')
      }
    },
    [showToast]
  )

  const loadEmulatorsForUser = React.useCallback(
    async (userId) => {
      if (userId == null) return
      const token = localStorage.getItem('token')
      setLoadingEmulatorsFor((p) => ({ ...p, [userId]: true }))
      try {
        const response = await fetch(`${USER_ASSIGN_EMULATOR_URL}/${userId}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          }
        })
        if (!response.ok) {
          showToast('Failed to load emulators for user', 'error')
          setEmulatorByUser((p) => ({ ...p, [userId]: [] }))
          return
        }
        const data = await response.json()
        const list = Array.isArray(data) ? data : []
        setEmulatorByUser((p) => ({ ...p, [userId]: list }))
      } catch (e) {
        console.error(e)
        showToast('Failed to load emulators for user', 'error')
        setEmulatorByUser((p) => ({ ...p, [userId]: [] }))
      } finally {
        setLoadingEmulatorsFor((p) => ({ ...p, [userId]: false }))
      }
    },
    [showToast]
  )

  React.useEffect(() => {
    if (userAssingedEmulator == null) return
    const uid =
      userAssingedEmulator.user?.id ?? userAssingedEmulator.userId ?? null
    if (uid == null) return
    setEmulatorByUser((prev) => {
      const next = { ...prev }
      delete next[uid]
      return next
    })
    refreshUserEmulatorCounts(uid)
    if (expandedIdsRef.current.has(uid)) {
      loadEmulatorsForUser(uid)
    }
  }, [userAssingedEmulator, loadEmulatorsForUser, refreshUserEmulatorCounts])

  const toggleExpand = async (userId) => {
    setExpandedIds((prev) => {
      const next = new Set(prev)
      if (next.has(userId)) {
        next.delete(userId)
      } else {
        next.add(userId)
        if (!emulatorByUser[userId]) {
          loadEmulatorsForUser(userId)
        }
      }
      return next
    })
  }

  const handleActionButtonClick = async (id, status) => {
    if (status === 'ENABLED') {
      status = 'DISABLED'
    } else {
      status = 'ENABLED'
    }
    const userStatusChange = {
      id,
      status
    }

    const token = localStorage.getItem('token')
    const response = await fetch(USER_CHANGE_STATUS_URL, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(userStatusChange)
    })
    if (!response.ok || response.status !== 200) {
      return { success: false, error: 'Failed to add user' }
    } else {
      status === 'ENABLED'
        ? showToast('User Enabled Successfully', 'success')
        : showToast('User Disabled Successfully', 'success')
    }
    const updatedData = userData.map((item) => {
      if (item.id === id) {
        return { ...item, status: userStatusChange.status }
      }
      return item
    })
    setUserData(updatedData)
  }

  const handleDeleteButtonClick = async (user) => {
    console.log('testUser:', user)
    if (user.tripId === null) {
      if (user) {
        const token = localStorage.getItem('token')
        const { success, error: err } = await ApiService.makeApiCall(
          USER_URL,
          'DELETE',
          null,
          token,
          user.id
        )

        if (success) {
          const updatedData = userData.filter((item) => item.id !== user.id)
          setUserData(updatedData)
          showToast('User deleted', 'success')
        } else {
          console.error('Error occurred while deleting user:', err)
          showToast('User not deleted', 'error')
        }
      }
    } else {
      showToast('Cannot delete the user with an active trip!', 'error')
    }
  }

  const fetchUsers = async () => {
    const token = localStorage.getItem('token')
    try {
      const response = await fetch(USER_URL, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      })
      if (!response.ok || response.status !== 200) {
        return { success: false, error: 'Invalid credentials' }
      } else {
        const responseData = await response.text()
        const deserializedData = JSON.parse(responseData)
        setUserData(deserializedData)
        setLoading(false)
        return { success: true, error: null }
      }
    } catch (err) {
      console.error('User Data Error: ' + err)
      setError(err.message)
      setLoading(false)
    }
  }

  React.useEffect(() => {
    setLoading(true)
    fetchUsers()
    setDataUpdated(true)
  }, [])

  const handleChangePage = (event, newPage) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - userData.length) : 0

  const visibleRows = React.useMemo(
    () =>
      stableSort(userData, getComparator(order, orderBy)).slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      ),
    [order, orderBy, page, userData, rowsPerPage]
  )

  const copySsid = (ssid) => {
    const text = ssid || ''
    if (!text) return
    navigator.clipboard.writeText(text).then(
      () => showToast('SSID copied', 'success'),
      () => showToast('Could not copy SSID', 'error')
    )
  }

  const updateInterval = async (emulatorRow, intervalVal, userId) => {
    if (!emulatorRow?.user) return
    const token = localStorage.getItem('token')
    try {
      const response = await fetch(`${UPDATE_INTERVAL(emulatorRow.id, intervalVal)}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      })
      if (response.ok || response.status === 200) {
        showToast('Interval updated successfully', 'success')
        setEmulatorByUser((p) => ({
          ...p,
          [userId]: (p[userId] || []).map((e) =>
            e.id === emulatorRow.id ? { ...e, updateInSec: intervalVal } : e
          )
        }))
      }
    } catch (e) {
      console.error('updateInterval error: ', e)
      showToast('Failed to update interval', 'error')
    }
    setIntervalMenu({ anchorEl: null, emulator: null, ownerUserId: null })
  }

  const handleNestedUnassign = async (row, userId) => {
    const token = localStorage.getItem('token')
    try {
      const response = await fetch(`${USER_ASSIGN_EMULATOR_URL}/${row.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      })
      if (!response.ok || response.status !== 200) {
        showToast('Failed to unassign user', 'error')
        return
      }
      if (setUserAssingedEmulator) {
        setUserAssingedEmulator({ user: { id: userId } })
      }
      showToast('User Un-Assigned', 'success')
      setEmulatorByUser((p) => ({
        ...p,
        [userId]: (p[userId] || []).filter((e) => e.id !== row.id)
      }))
      refreshUserEmulatorCounts(userId)
      if (typeof updatedEmulator === 'function') {
        updatedEmulator()
      }
    } catch (e) {
      showToast(`Failed to unassign user ${e}`, 'error')
    }
  }

  const handleNestedDeleteEmulator = async (emulator, userId) => {
    if (!emulator?.emulatorSsid) return
    const token = localStorage.getItem('token')
    const { success } = await ApiService.makeApiCall(
      EMULATOR_DELETE_URL,
      'DELETE',
      null,
      token,
      emulator.id
    )
    if (success) {
      showToast('Emulator deleted', 'success')
      setEmulatorByUser((p) => ({
        ...p,
        [userId]: (p[userId] || []).filter((e) => e.id !== emulator.id)
      }))
      refreshUserEmulatorCounts(userId)
      if (typeof updatedEmulator === 'function') {
        updatedEmulator()
      }
    } else {
      showToast('Emulator not deleted', 'error')
    }
  }

  if (error) {
    return (
      <>
        <div className="error">
          <h1>Something went wrong!</h1>
          <p>Error: {error}</p>
          <EnhancedTableToolbar handleOpen={handleOpen} />
        </div>
      </>
    )
  }

  const visibleRowsWithTripIds = visibleRows.map((visibleRow) => {
    const matchingEmulator = totalEmulators.find(
      (emulator) => emulator?.user?.id === visibleRow?.id
    )

    return {
      ...visibleRow,
      tripId: matchingEmulator ? matchingEmulator?.tripId : null
    }
  })

  const isInteractiveTarget = (target) =>
    target.closest(
      'button, a, [role="button"], input, select, .MuiIconButton-root, .MuiSelect-select, .MuiMenuItem-root'
    )

  return (
    <Box sx={{ width: '100%' }}>
      <Paper sx={{ width: '100%', mb: 2, boxShadow: 'none' }}>
        <EnhancedTableToolbar handleOpen={handleOpen} />
        <TableContainer
          sx={{
            overflowX: 'auto',
            '&::-webkit-scrollbar': { height: '10px' },
            '&::-webkit-scrollbar-track': {
              backgroundColor: '#fffff',
              borderRadius: '10px'
            },
            '&::-webkit-scrollbar-thumb': {
              backgroundColor: '#2C6FEB',
              borderRadius: '10px'
            },
            '&::-webkit-scrollbar-thumb:hover': { backgroundColor: '#2C6FEB' }
          }}
        >
          {loading ? (
            <div
              style={{
                textAlign: 'center',
                marginTop: '20vh',
                marginBottom: '20vh'
              }}
            >
              <CircularProgress />
            </div>
          ) : (
            <Table
              sx={{ minWidth: 750 }}
              aria-labelledby="tableTitle"
              size={'small'}
              className="main-user-table"
            >
              <TableHead className="main-table-header">
                <TableRow>
                  {[
                    '',
                    'Number',
                    'User',
                    'Email',
                    'Tel.#',
                    'Registered',
                    'Emulator',
                    'Actions'
                  ].map((header) => (
                    <TableCell
                      key={header || 'expand'}
                      className="table-header"
                      sx={{
                        flexGrow: 1,
                        textAlign: 'center',
                        ...(header === 'Actions'
                          ? {
                              width: '80px',
                              minWidth: '80px',
                              flexGrow: 0,
                              fontFamily: '"Poppins", sans-serif !important',
                              fontWeight: '600 !important',
                              fontSize: '18px',
                              letterSpacing: '0rem'
                            }
                          : {
                              fontFamily: '"Poppins", sans-serif !important',
                              fontWeight: '600 !important',
                              fontSize: '18px',
                              letterSpacing: '0rem'
                            })
                      }}
                    >
                      {header}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody>
                {visibleRowsWithTripIds.map((row, index) => {
                  const labelId = `enhanced-table-checkbox-${index}`
                  const serial = page * rowsPerPage + index + 1
                  const onlineEmulator =
                    row.emulatorCount?.activeEmulatorsCount ?? 0
                  const allEmulator = row.emulatorCount?.allEmulatorsCount ?? 0
                  const expanded = expandedIds.has(row.id)
                  const nested = emulatorByUser[row.id]
                  const nestedLoading = loadingEmulatorsFor[row.id]

                  return (
                    <React.Fragment key={row.id}>
                      <TableRow
                        hover
                        tabIndex={-1}
                        onClick={(e) => {
                          if (isInteractiveTarget(e.target)) return
                          toggleExpand(row.id)
                        }}
                        sx={{
                          cursor: 'pointer',
                          '& > *': { borderBottom: expanded ? 0 : undefined }
                        }}
                      >
                        <TableCell align="center" className="table-cell" sx={{ width: 48 }}>
                          <IconButton
                            size="small"
                            onClick={(e) => {
                              e.stopPropagation()
                              toggleExpand(row.id)
                            }}
                            aria-expanded={expanded}
                            aria-label={expanded ? 'Collapse' : 'Expand'}
                          >
                            <ExpandMoreIcon
                              sx={{
                                transform: expanded ? 'rotate(180deg)' : 'none',
                                transition: 'transform 0.2s'
                              }}
                            />
                          </IconButton>
                        </TableCell>
                        <TableCell align="left" className="table-cell">
                          <span className="emulator-id table-id-font-alignment">
                            {serial}
                          </span>
                        </TableCell>

                        <TableCell
                          id={labelId}
                          scope="row"
                          className="custom-font table-cell"
                        >
                          <span className="emulator-table-content-font">
                            {`${row.firstName || ''} ${row.lastName || ''}`.trim() ||
                              'N/A'}
                          </span>
                        </TableCell>

                        <TableCell align="left" className="custom-font table-cell">
                          <span className="emulator-table-content-font">
                            {row.email || 'N/A'}
                          </span>
                        </TableCell>

                        <TableCell align="left" className="custom-font table-cell">
                          <span className="emulator-table-content-font">
                            {row.telephone || 'N/A'}
                          </span>
                        </TableCell>

                        <TableCell align="left" className="custom-font table-cell">
                          <span className="emulator-table-content-font">
                            {formatRegisteredDate(row.createdAt)}
                          </span>
                        </TableCell>

                        <TableCell align="left" className="custom-font table-cell">
                          <Tooltip
                            title={`${onlineEmulator} active out of ${allEmulator} assigned`}
                            placement="top"
                          >
                            <span className="emulator-table-content-font">
                              {onlineEmulator > 0 ? (
                                <>
                                  {onlineEmulator}
                                  <OnlinePredictionIcon color="success" sx={{ fontSize: 18, verticalAlign: 'text-bottom', ml: 0.5 }} />
                                </>
                              ) : (
                                0
                              )}
                              /{allEmulator}
                            </span>
                          </Tooltip>
                        </TableCell>

                        <TableCell align="left" className="table-cell-for-action">
                          <div
                            className="d-flex align-items-center justify-content-center flex-column"
                            onClick={(e) => e.stopPropagation()}
                          >
                            <div className="d-flex align-items-center justify-content-center flex-sm-row">
                              <button
                                className="enable-button"
                                style={{
                                  backgroundColor:
                                    row.status === 'ENABLED'
                                      ? '#2C6FEB'
                                      : '#000000',
                                  color:
                                    row.status === 'ENABLED' ? '#FFFF' : '#FFFF'
                                }}
                                data-bs-toggle="modal"
                                data-bs-target="#assignunassignmodal"
                                onClick={() =>
                                  setEnableDisableDeatils({
                                    ...enableDisableDetails,
                                    id: row.id,
                                    status: row.status
                                  })
                                }
                              >
                                <span className="emulator-table-content-font">
                                  {row.status}
                                </span>
                              </button>

                              <IconButton
                                className="edit-user-button"
                                onClick={() => handleEditButtonClick(row)}
                              >
                                <img
                                  src={'images/edit-icon.svg'}
                                  alt="edit-icon"
                                />
                              </IconButton>

                              <IconButton
                                className="delete-button"
                                data-bs-toggle="modal"
                                data-bs-target="#myUserModal"
                                onClick={() => setUserDetails(row)}
                              >
                                <img
                                  src={'images/delete-icon.svg'}
                                  alt="delete-icon"
                                />
                              </IconButton>
                            </div>
                          </div>
                        </TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell
                          colSpan={8}
                          sx={{
                            py: 0,
                            borderBottom: expanded ? undefined : 'none',
                            bgcolor: expanded ? '#fafafa' : 'transparent'
                          }}
                        >
                          <Collapse in={expanded} timeout="auto" unmountOnExit>
                            <Box sx={{ py: 2, px: 1 }}>
                              {nestedLoading ? (
                                <Box sx={{ textAlign: 'center', py: 2 }}>
                                  <CircularProgress size={28} />
                                </Box>
                              ) : (
                                <Table size="small" sx={{ minWidth: 650 }}>
                                  <TableHead>
                                    <TableRow>
                                      {[
                                        'Number',
                                        'Emulator Name',
                                        'Assigned User',
                                        'SSID',
                                        'Update Interval',
                                        'Registered',
                                        'Status',
                                        'Action'
                                      ].map((h) => (
                                        <TableCell
                                          key={h}
                                          sx={{
                                            fontWeight: 600,
                                            fontFamily: '"Poppins", sans-serif'
                                          }}
                                        >
                                          {h}
                                        </TableCell>
                                      ))}
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {(nested || []).length === 0 ? (
                                      <TableRow>
                                        <TableCell colSpan={7}>
                                          No emulators assigned to this user.
                                        </TableCell>
                                      </TableRow>
                                    ) : (
                                      (nested || []).map((emu, i) => (
                                        <TableRow key={emu.id}>
                                          <TableCell>{i + 1}</TableCell>
                                          <TableCell className="emulator-table-content-font">
                                            {emu.emulatorName || 'N/A'}
                                          </TableCell>
                                          <TableCell className="emulator-table-content-font">
                                            {emu.user
                                              ? `${emu.user.firstName || ''} ${emu.user.lastName || ''}`.trim() ||
                                                '—'
                                              : '—'}
                                          </TableCell>
                                          <TableCell>
                                            <Box
                                              sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 0.5
                                              }}
                                            >
                                              <Tooltip title={emu.emulatorSsid || ''}>
                                                <span
                                                  className="emulator-table-content-font"
                                                  style={{
                                                    maxWidth: 140,
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    whiteSpace: 'nowrap',
                                                    display: 'inline-block'
                                                  }}
                                                >
                                                  {emu.emulatorSsid || 'N/A'}
                                                </span>
                                              </Tooltip>
                                              {handleGeneratedIdButtonClick && (
                                                <IconButton
                                                  size="small"
                                                  onClick={() =>
                                                    handleGeneratedIdButtonClick(emu)
                                                  }
                                                  aria-label="Edit SSID"
                                                >
                                                  <EditOutlinedIcon fontSize="small" />
                                                </IconButton>
                                              )}
                                              <IconButton
                                                size="small"
                                                onClick={() =>
                                                  copySsid(emu.emulatorSsid)
                                                }
                                                aria-label="Copy SSID"
                                              >
                                                <ContentCopyIcon fontSize="small" />
                                              </IconButton>
                                            </Box>
                                          </TableCell>
                                          <TableCell>
                                            <Box
                                              sx={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: 0.5
                                              }}
                                            >
                                              <span className="emulator-table-content-font">
                                                {emu.updateInSec != null
                                                  ? `${emu.updateInSec}s`
                                                  : 'N/A'}
                                              </span>
                                              <IconButton
                                                size="small"
                                                disabled={!emu.user}
                                                onClick={(e) =>
                                                  setIntervalMenu({
                                                    anchorEl: e.currentTarget,
                                                    emulator: emu,
                                                    ownerUserId: row.id
                                                  })
                                                }
                                                aria-label="Change update interval"
                                              >
                                                <EditOutlinedIcon fontSize="small" />
                                              </IconButton>
                                            </Box>
                                          </TableCell>
                                          <TableCell className="emulator-table-content-font">
                                            {emu.createdAt
                                              ? formatRegisteredDate(emu.createdAt)
                                              : 'N/A'}
                                          </TableCell>
                                          <TableCell>
                                            <Box
                                              component="span"
                                              sx={{
                                                ...statusBadgeSx(emu.status),
                                                borderRadius: '999px',
                                                px: 1.5,
                                                py: 0.5,
                                                fontSize: '0.75rem',
                                                fontWeight: 600,
                                                display: 'inline-block',
                                                textTransform: 'capitalize'
                                              }}
                                            >
                                              {emu.status || 'N/A'}
                                            </Box>
                                          </TableCell>
                                          <TableCell>
                                            <Box
                                              sx={{
                                                display: 'flex',
                                                gap: 0.5,
                                                flexWrap: 'wrap'
                                              }}
                                            >
                                              <button
                                                type="button"
                                                className={`assign-button ${emu.user ? 'assigned' : 'unassigned'}`}
                                                aria-label={
                                                  emu.user
                                                    ? 'Unassign emulator'
                                                    : 'Assign emulator'
                                                }
                                                onClick={() => {
                                                  if (!emu.user) return
                                                  setNestedUnassignDetails({
                                                    emulator: emu,
                                                    userId: row.id
                                                  })
                                                }}
                                                onKeyDown={(e) => {
                                                  if (
                                                    (e.key === 'Enter' ||
                                                      e.key === ' ') &&
                                                    emu.user
                                                  ) {
                                                    e.preventDefault()
                                                    setNestedUnassignDetails({
                                                      emulator: emu,
                                                      userId: row.id
                                                    })
                                                  }
                                                }}
                                                data-bs-toggle={
                                                  emu.user ? 'modal' : undefined
                                                }
                                                data-bs-target={
                                                  emu.user
                                                    ? '#nestedUnassignEmulatorModal'
                                                    : undefined
                                                }
                                                style={{
                                                  display: 'inline-flex',
                                                  alignItems: 'center',
                                                  gap: '6px'
                                                }}
                                              >
                                                {emu.user ? 'Unassign' : 'Assign'}
                                                <span
                                                  className={
                                                    emu.user
                                                      ? 'minus-bg icon-button'
                                                      : 'add-bg icon-button'
                                                  }
                                                  style={{
                                                    pointerEvents: 'none',
                                                    display: 'inline-flex',
                                                    width: '21px',
                                                    height: '21px',
                                                    borderRadius: '50%',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    float: 'none',
                                                    marginLeft: 'auto'
                                                  }}
                                                >
                                                  <span
                                                    id="alignAddBtn"
                                                    style={{
                                                      width: '13px',
                                                      height: '13px',
                                                      display: 'inline-flex',
                                                      alignItems: 'center',
                                                      justifyContent: 'center',
                                                      lineHeight: 0
                                                    }}
                                                  >
                                                    <img
                                                      src={
                                                        emu.user
                                                          ? 'images/minus-icon.svg'
                                                          : 'images/add-icon.svg'
                                                      }
                                                      alt={
                                                        emu.user
                                                          ? 'minus-icon'
                                                          : 'add-icon'
                                                      }
                                                      width={13}
                                                      height={13}
                                                      style={{
                                                        display: 'block',
                                                        objectFit: 'contain',
                                                        verticalAlign: 'middle'
                                                      }}
                                                    />
                                                  </span>
                                                </span>
                                              </button>
                                              <Tooltip title="Delete emulator">
                                                <IconButton
                                                  className="delete-button"
                                                  size="small"
                                                  aria-label="Delete emulator"
                                                  data-bs-toggle="modal"
                                                  data-bs-target="#nestedDeleteEmulatorModal"
                                                  onClick={() =>
                                                    setNestedDeleteDetails({
                                                      emulator: emu,
                                                      userId: row.id
                                                    })
                                                  }
                                                >
                                                  <img
                                                    src={'images/delete-icon.svg'}
                                                    alt=""
                                                  />
                                                </IconButton>
                                              </Tooltip>
                                            </Box>
                                          </TableCell>
                                        </TableRow>
                                      ))
                                    )}
                                  </TableBody>
                                </Table>
                              )}
                            </Box>
                          </Collapse>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  )
                })}
                {emptyRows > 0 && (
                  <TableRow
                    style={{
                      height: 33 * emptyRows
                    }}
                  >
                    <TableCell colSpan={8} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          )}
        </TableContainer>
      </Paper>
      <Menu
        anchorEl={intervalMenu.anchorEl}
        open={Boolean(intervalMenu.anchorEl)}
        onClose={() =>
          setIntervalMenu({ anchorEl: null, emulator: null, ownerUserId: null })
        }
      >
        {INTERVAL_OPTIONS.map((opt) => (
          <MenuItem
            key={opt.value}
            onClick={() =>
              updateInterval(
                intervalMenu.emulator,
                opt.value,
                intervalMenu.ownerUserId
              )
            }
          >
            {opt.label}
          </MenuItem>
        ))}
      </Menu>
      <div className="alignPagination">
        <CustomTablePagination
          rowsPerPageOptions={[10, 30, 50]}
          count={userData.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          style={{ overflow: 'hidden' }}
        />
      </div>

      <div className="modal" id="myUserModal">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content" style={{ borderRadius: '4px' }}>
            <div className="modal-header">
              <h4 className="modal-title delete-modal-heading">Delete User</h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>

            <div className="modal-body delete-modal-sub-heading">
              Are you sure you want to delete this user:{' '}
              {userDetails?.firstName + ' ' + userDetails?.lastName}?
            </div>

            <div className="modal-footer border-top-0">
              <button
                type="button"
                data-bs-dismiss="modal"
                className="mb-3"
                style={{
                  backgroundColor: '#00C72E',
                  color: '#ffff',
                  border: 'none',
                  width: '97px',
                  height: '38px',
                  borderRadius: '4px'
                }}
                onClick={() => handleDeleteButtonClick(userDetails)}
              >
                Ok
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="modal" id="assignunassignmodal">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content" style={{ borderRadius: '4px' }}>
            <div className="modal-header">
              <h4 className="modal-title delete-modal-heading">{`${enableDisableDetails.status === 'DISABLED' ? 'Enable' : 'Disable'} User`}</h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>

            <div className="modal-body delete-modal-sub-heading">
              {`Are you sure you want to ${enableDisableDetails.status === 'DISABLED' ? 'Enable' : 'Disable'} User?`}
            </div>

            <div className="modal-footer d-flex border-top-0">
              <Button
                style={{
                  backgroundColor: '#00C72E',
                  color: '#ffff',
                  border: 'none',
                  width: '97px',
                  height: '38px',
                  borderRadius: '4px'
                }}
                data-bs-dismiss="modal"
                className="global-font rounded-2 py-2 fw-medium ms-0 mb-3"
                type="submit"
                onClick={() =>
                  handleActionButtonClick(
                    enableDisableDetails.id,
                    enableDisableDetails.status
                  )
                }
              >
                Ok
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div className="modal" id="nestedDeleteEmulatorModal">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content" style={{ borderRadius: '4px' }}>
            <div className="modal-header">
              <h4 className="modal-title delete-modal-heading">
                Delete Emulator
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body delete-modal-sub-heading">
              Are you sure you want to delete this emulator:{' '}
              {nestedDeleteDetails?.emulator?.emulatorSsid}?
            </div>
            <div className="modal-footer d-flex border-top-0">
              <Button
                style={{
                  backgroundColor: '#00C72E',
                  color: '#ffff',
                  border: 'none',
                  width: '97px',
                  height: '38px',
                  borderRadius: '4px'
                }}
                data-bs-dismiss="modal"
                className="global-font py-2 fw-medium ms-0 mb-3"
                type="submit"
                onClick={() => {
                  if (nestedDeleteDetails?.emulator && nestedDeleteDetails?.userId) {
                    handleNestedDeleteEmulator(
                      nestedDeleteDetails.emulator,
                      nestedDeleteDetails.userId
                    )
                  }
                }}
              >
                Ok
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div className="modal" id="nestedUnassignEmulatorModal">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content" style={{ borderRadius: '4px' }}>
            <div className="modal-header">
              <h4 className="modal-title delete-modal-heading">
                Unassign Emulator
              </h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body delete-modal-sub-heading">
              Are you sure you want to unassign this emulator:{' '}
              {nestedUnassignDetails?.emulator?.emulatorSsid}?
            </div>
            <div className="modal-footer d-flex border-top-0">
              <Button
                style={{
                  backgroundColor: '#00C72E',
                  color: '#ffff',
                  border: 'none',
                  width: '97px',
                  height: '38px',
                  borderRadius: '4px'
                }}
                data-bs-dismiss="modal"
                className="global-font py-2 fw-medium ms-0 mb-3"
                type="submit"
                onClick={() => {
                  if (
                    nestedUnassignDetails?.emulator &&
                    nestedUnassignDetails?.userId
                  ) {
                    handleNestedUnassign(
                      nestedUnassignDetails.emulator,
                      nestedUnassignDetails.userId
                    )
                  }
                }}
              >
                Ok
              </Button>
            </div>
          </div>
        </div>
      </div>
    </Box>
  )
}
